<shared-toolbar title="Empresa">
  <shared-search-field (inputValue)="fielInput = $event" [data]="dataSource" />
  <shared-button
    (click)="modalAction()"
    [typeBtn]="'button'"
    [color]="'accent'"
    [icon]="'add'"
    >Agregar
  </shared-button>
</shared-toolbar>
<mat-card class="mt-4 p-0 overflow-hidden">
  <mat-card-content class="overflow-y-hidden overflow-x-scroll">
    <table mat-table class="w-full" [dataSource]="dataSource" matSort>
      <!-- Position Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
        <td
          mat-cell
          [style]="getRowStyles(element.status)"
          *matCellDef="let element">
          {{ element.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="nit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nit/RUC</th>
        <td
          mat-cell
          [style]="getRowStyles(element.status)"
          *matCellDef="let element">
          {{ element.nit }}
        </td>
      </ng-container>
      <ng-container matColumnDef="contractNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Número de contrato
        </th>
        <td
          mat-cell
          [style]="getRowStyles(element.status)"
          *matCellDef="let element">
          {{ element.contractNumber }}
        </td>
      </ng-container>
      <ng-container matColumnDef="invoiceNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Número de factura
        </th>
        <td
          mat-cell
          [style]="getRowStyles(element.status)"
          *matCellDef="let element">
          {{ element.invoiceNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Claro ID</th>
        <td
          mat-cell
          [style]="getRowStyles(element.status)"
          *matCellDef="let element">
          {{ element.code | uppercase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="manager">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Representante</th>
        <td
          mat-cell
          [style]="getRowStyles(element.status)"
          *matCellDef="let element">
          {{ element.manager }}
        </td>
      </ng-container>

      <ng-container matColumnDef="manager-contact">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contacto</th>
        <td
          mat-cell
          [style]="getRowStyles(element.status)"
          *matCellDef="let element">
          {{ element.managerContact }}
        </td>
      </ng-container>

      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Dirección</th>
        <td
          mat-cell
          [style]="getRowStyles(element.status)"
          *matCellDef="let element">
          {{ element.address }}
        </td>
      </ng-container>

      <ng-container matColumnDef="usersCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Cantidad de trabajadores
        </th>
        <td
          mat-cell
          [style]="getRowStyles(element.status)"
          *matCellDef="let element">
          {{ element.usersCount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="usersCreated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Usuarios disponibles
        </th>
        <td
          mat-cell
          [style]="getRowStyles(element.status)"
          *matCellDef="let element">
          {{ element.usersCount - element.usersCreated }}
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
            <td mat-cell *matCellDef="let element">{{ element.state }}</td>
          </ng-container> -->

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td
          mat-cell
          [style]="getRowStyles(element.status)"
          *matCellDef="let element">
          <button
            mat-icon-button
            color="accent"
            [matMenuTriggerFor]="menu"
            aria-label="Mas opciones">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <a mat-menu-item (click)="viewBuildingsByCompany(element)">
              <mat-icon mat-icon-button>apartment</mat-icon>
              <span>Edificios</span>
            </a>

            <a mat-menu-item (click)="modalLicences(element)">
              <mat-icon mat-icon-button>badge</mat-icon>
              <span>Actualizar licencias</span>
            </a>
            <a mat-menu-item (click)="modalAction(element)">
              <mat-icon mat-icon-button>edit</mat-icon>
              <span>Editar</span>
            </a>

            <a mat-menu-item (click)="arrearsCompany(element)">
              <mat-icon mat-icon-button>notification_important</mat-icon>
              <span>Notificar Mora</span>
            </a>

            @if (element.status == 2) {
              <a mat-menu-item (click)="reactivateCompany(element)">
                <mat-icon mat-icon-button color="warn">cloud_upload</mat-icon>
                <span>Activar</span>
              </a>
            }
            @if (element.status == 1) {
              <a mat-menu-item (click)="suspendCompany(element)">
                <mat-icon mat-icon-button color="warn">cloud_off</mat-icon>
                <span>Suspender</span>
              </a>
            }
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">
          No hay resultados para la busqueda: {{ fielInput }}
        </td>
      </tr>
    </table>

    <br />
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>
  </mat-card-content>
</mat-card>
